module.exports = __webpack_public_path__ + "static/media/excel.cb7f7670.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/excel.svg
// module id = 132
// module chunks = 0